@let forbiddenPermissionsMessage = 'general.forbidden_action' | translate;

<form [formGroup]="form">
  <div>
    <div class="mb-2 subtitle">
      {{ 'page.general_settings.address' | translate }}
    </div>
  </div>
  <div class="row">
    <div class="w-100">
      <div>
        <div class="form-group">
          <label for="address">
            {{ 'page.general_settings.address.street' | translate }}
          </label>
          <input
            [class.is-invalid]="
              (form.controls['street'] | formControlInvalid: false) ||
              form.controls['street'].invalid
            "
            type="text"
            class="rounded-0"
            id="street"
            nz-input
            nz-tooltip
            [nzTooltipTitle]="
              !hasGeneralSettingsUpdatePermission
                ? forbiddenPermissionsMessage
                : ''
            "
            formControlName="street"
            placeholder="{{ 'general.input' | translate }}"
            (blur)="onAddressChange()"
          />
        </div>
      </div>
      <div class="d-flex form-row">
        <div class="form-group input-field">
          <label for="city">
            {{ 'page.general_settings.address.city' | translate }}
          </label>
          <input
            [class.is-invalid]="
              (form.controls['city'] | formControlInvalid) ||
              form.controls['city'].invalid
            "
            type="text"
            class="rounded-0"
            id="city"
            nz-input
            formControlName="city"
            placeholder="{{ 'general.input' | translate }}"
            nz-tooltip
            [nzTooltipTitle]="
              !hasGeneralSettingsUpdatePermission
                ? forbiddenPermissionsMessage
                : ''
            "
            (blur)="onAddressChange()"
          />
        </div>

        <div class="form-group input-field">
          <label for="postCode">
            {{ 'page.general_settings.address.postal_code' | translate }}
          </label>
          <input
            [class.is-invalid]="
              (form.controls['postCode'] | formControlInvalid) ||
              form.controls['postCode'].invalid
            "
            type="text"
            class="rounded-0"
            id="postCode"
            nz-input
            formControlName="postCode"
            placeholder="{{ 'general.input' | translate }}"
            nz-tooltip
            [nzTooltipTitle]="
              !hasGeneralSettingsUpdatePermission
                ? forbiddenPermissionsMessage
                : ''
            "
            (blur)="onAddressChange()"
          />
        </div>
      </div>

      <div class="d-flex form-row">
        <div class="form-group input-field">
          <label for="state">
            {{ 'page.general_settings.address.state' | translate }}
          </label>
          <input
            [class.is-invalid]="
              (form.controls['state'] | formControlInvalid) ||
              form.controls['state'].invalid
            "
            type="text"
            class="rounded-0"
            id="state"
            nz-input
            formControlName="state"
            placeholder="{{ 'general.input' | translate }}"
            nz-tooltip
            [nzTooltipTitle]="
              !hasGeneralSettingsUpdatePermission
                ? forbiddenPermissionsMessage
                : ''
            "
            (blur)="onAddressChange()"
          />
        </div>

        <div class="form-group input-field">
          <label for="country">
            {{ 'page.general_settings.address.country' | translate }}
          </label>
          <input
            [class.is-invalid]="
              (form.controls['country'] | formControlInvalid) ||
              form.controls['country'].invalid
            "
            type="text"
            class="rounded-0"
            id="country"
            nz-input
            formControlName="country"
            placeholder="{{ 'general.input' | translate }}"
            nz-tooltip
            [nzTooltipTitle]="
              !hasGeneralSettingsUpdatePermission
                ? forbiddenPermissionsMessage
                : ''
            "
            (blur)="onAddressChange()"
          />
        </div>
      </div>
    </div>
  </div>
</form>
